/**
 * Shared helpers for file inputs with preview (use with `FileUploadWithPreview`).
 */

const API_BASE = (typeof process !== "undefined" && process.env.REACT_APP_API_URL) || "";

/** Turn API-relative paths into absolute URLs for <img src> / links. */
export function resolveMediaUrl(pathOrUrl) {
  if (pathOrUrl == null || pathOrUrl === "") return "";
  const s = String(pathOrUrl).trim();
  if (!s) return "";
  if (/^(https?:|data:|blob:)/i.test(s)) return s;
  const base = (API_BASE || (typeof window !== "undefined" ? window.location.origin : "") || "").replace(
    /\/$/,
    ""
  );
  const path = s.startsWith("/") ? s : `/${s}`;
  return `${base}${path}`;
}

export function isImageMime(type) {
  return /^image\//.test(type || "");
}

export function isLikelyImageUrl(url) {
  return /\.(jpe?g|png|gif|webp|bmp|svg)(\?|#|$)/i.test(String(url || ""));
}

export function isLikelyPdfUrl(url) {
  return /\.pdf(\?|#|$)/i.test(String(url || ""));
}

/**
 * Find an existing file URL on a user/document object from common backend shapes.
 * Tries: `fieldKey_url`, `fieldKey_path`, nested `documents[fieldKey]`, etc.
 */
export function pickExistingFileUrl(record, fieldKey) {
  if (!record || !fieldKey) return null;
  const base = fieldKey.replace(/_image$/, "");
  const keys = [
    `${fieldKey}_url`,
    `${fieldKey}_path`,
    `${fieldKey}_link`,
    `${base}_url`,
    `${base}_path`,
    `${base}_image_url`,
    fieldKey
  ];
  for (const k of keys) {
    const v = record[k];
    if (typeof v === "string" && v.trim()) return v.trim();
  }
  for (const nestKey of ["documents", "files", "media", "attachments"]) {
    const nest = record[nestKey];
    if (nest && typeof nest === "object") {
      const v = nest[fieldKey] ?? nest[base];
      if (typeof v === "string" && v.trim()) return v.trim();
      const o = nest[fieldKey] ?? nest[base];
      if (o && typeof o === "object") {
        const u = o.url ?? o.path ?? o.src;
        if (typeof u === "string" && u.trim()) return u.trim();
      }
    }
  }
  return null;
}
